import { Injectable } from '@angular/core';

import { AppConstants } from 'src/app/shared/entity/constants';
import { CommandType, RouteState } from 'src/app/shared/entity/enums';
import { ConnectionService } from 'src/app/shared/services/connection/connection.service';
import { Routes } from 'src/app/shared/models/kpi-details';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { CommonService } from 'src/app/shared/services/common/common.service';

@Injectable({
  providedIn: 'root'
})
export class RouteConfigurationService {
  constructor(
    private readonly connectionService: ConnectionService,
    private readonly dataRepositoryService: DataRepositoryService,
    private readonly commonService: CommonService
  ) {
  }

  /**
   * This method calls command API to update the route status as complete
   * @param route details
   */
  markRouteComplete(route: Routes) {
    const blId = this.dataRepositoryService.selectedBusinessLocation;
    const commandPayload = this.getRouteCompleteCommand(route.route_id, blId);
    return this.connectionService
      .httpReq({
          reqType:AppConstants.POSTREQUEST,
          endUrl: AppConstants.Command,
          isLoader: false,
          directoryType: AppConstants.DP,
          data: commandPayload
      });
  }

  /**
   * Get mark route complete command payload
   * @param routeId - selected route id to complete
   * @param blId - current select BL in main filter
   * @returns - payload for command API to complete route of type ChangeRouteState
   */
  getRouteCompleteCommand(routeId: string, blId: string) {
    return [
      {
        id: crypto.randomUUID(),
        command_type: CommandType.ChangeRouteState,
        state: this.commonService.capitalizeFirstLetter(RouteState.Completed),
        timestamp: new Date(),
        route_id: routeId,
        bl_id: blId
      }
    ]
  }
}